'use client'

import { useEffect } from 'react'
import { datadogLogs } from '@datadog/browser-logs'

import ErrorSection from '@components/errorSection'

type ErrorProps = {
  error: Error & { digest?: string }
}

export default function GlobalError({ error }: ErrorProps) {
  useEffect(() => {
    if (!error) return

    datadogLogs.logger.error(`Erro ${error}`)
  }, [error])

  return <ErrorSection />
}

